import React, { useEffect, useRef, useState } from "react";
import "../Buliding/buliding.css";
import { Modal, Form, Offcanvas } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { io } from "socket.io-client";
import { format2 } from "../../utils/money";

const socket = io("https://toptennis.io", { // https://toptennis.io
  auth: {
    token: localStorage.getItem("user_token"),
  },
});

function Building() {
  const [show, setShow] = useState(false);
  const [players, setPlayers] = useState([]); // Store all players from socket
  const [selectedIcons, setSelectedIcons] = useState(Array(8).fill(null));
  const [selectedPlayers, setSelectedPlayers] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [playerShares, setPlayerShares] = useState({});
  const [totalSpent, setTotalSpent] = useState(0);
  const [isMarketFrozen, setIsMarketFrozen] = useState(false);
  const [frozenUsers, setFrozenUsers] = useState();
  const [freezeMessage, setFreezeMessage] = useState("");
  const [userName, setUserName] = useState("");
  const [inPlayValue, setInPlayValue] = useState(0);
  const [credits, setCredits] = useState(0);
  const [withdrawableCredits, setWithdrawableCredits] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [buyPlayer, setBuyPlayer] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [filteredPlayers, setFilteredPlayers] = useState([]);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [buyModal, setBuyModal] = useState(false);
  const [playerHasReached20, setPlayerHasReached20] = useState({});
  const [differenceValue, setDifferenceValue] = useState(0);
  const [playerval, setplayerval] = useState(0);
  const [teamCost, setTeamCost] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [currentInput, setCurrentInput] = useState(0);
  const [teamInput, setTeamInput] = useState(0);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [totalDeposit, setTotalDeposit] = useState(0);
  const [isFirstTeamCreated, setIsFirstTeamCreated] = useState(false);
  const [userInPlayData, setUserInPlayData] = useState({}); // New state for in-play value data
  const isFirstLoad = useRef(true);
  const [sortOption, setSortOption] = useState("Player name A-Z");
  const [randomlyAddedPlayerId, setRandomlyAddedPlayerId] = useState(null); // DO NOT Remove Its for future scope
  const navigate = useNavigate();

  const handleSubscribe = async () => {
    if (!email) {
      setMessage("Please enter a valid email.");
      return;
    }

    try {
      const response = await fetch(
        "https://api.convertkit.com/v3/forms/7878458/subscribe",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            api_key: "3bkwOyREXJsvpFPZ5iUAAw",
            email: email,
          }),
        }
      );

      const data = await response.json();
      if (data.subscription) {
        setMessage(
          "Success! Please check your email to confirm your subscription."
        );
        setEmail("");
      } else {
        setMessage(data.message || "Something went wrong.");
      }
    } catch (error) {
      setMessage("Subscription failed. Please try again later.");
      console.error(error);
    }
  };

  const cleanupPendingSelection = () => {
    if (!selectedPlayer) return;

    const playerId = selectedPlayer._id;

    // Revert player selected flag
    setPlayers((prev) =>
      prev.map((p) =>
        p._id === playerId ? { ...p, selected: false } : p
      )
    );

    // Remove from selectedPlayers
    setSelectedPlayers((prev) => prev.filter((p) => p._id !== playerId));

    // Remove from shares
    setPlayerShares((prev) => {
      const updated = { ...prev };
      delete updated[playerId];
      return updated;
    });

    // Optional: revert icons if you manage them separately
    // setSelectedIcons(...)

    // Clear temporary states
    setSelectedPlayer(null);
    setBuyModal(false);
    // setRandomlyAddedPlayerId(null);  // if still using
  };
  const handleBuyClose = () => {
    if (randomlyAddedPlayerId) {
      // Unselect player
      setPlayers((prevPlayers) =>
        prevPlayers.map((p) =>
          p._id === randomlyAddedPlayerId
            ? { ...p, selected: false }
            : p
        )
      );

      // Remove from selectedPlayers
      setSelectedPlayers((prev) =>
        prev.filter((p) => p._id !== randomlyAddedPlayerId)
      );

      // Remove share entry
      setPlayerShares((prev) => {
        const updated = { ...prev };
        delete updated[randomlyAddedPlayerId];
        return updated;
      });

      setSelectedPlayer(null);
      setRandomlyAddedPlayerId(null);
    }
    cleanupPendingSelection();
    setBuyModal(false);
  };


  useEffect(() => {
    socket.on("userFreezeUpdate", (data) => {
      setFrozenUsers(data.isFrozen);
      console.log("Received user freeze update:", data.isFrozen);
    });

    return () => {
      socket.off("userFreezeUpdate");
    };
  }, []);

  const handleBuyPlayer1 = (playerId, iconIndex) => {
    if (isMarketFrozen) {
      showAutoError("Player purchases are currently disabled");
      return;
    }
    if (frozenUsers) {
      showAutoError("Player purchases are currently disabled");
      return;
    }
    const selectedPlayer = players.find((player) => player._id === playerId);
    if (!selectedPlayer) return;

    setPlayerShares((prevShares) => ({
      ...prevShares,
      [playerId]: prevShares[playerId] === undefined ? 1 : prevShares[playerId],
    }));

    if (selectedPlayer.selected) {
      setPlayers((prevPlayers) =>
        prevPlayers.map((player) =>
          player._id === playerId ? { ...player, selected: false } : player
        )
      );

      setSelectedPlayers((prevSelected) =>
        prevSelected.filter((p) => p._id !== playerId)
      );
    } else {
      const currentSelectedSum = players.reduce(
        (acc, p) => acc + (p.selected ? (Number(p.value) || 0) : 0),
        0
      );
      const newTotalSpent = currentSelectedSum + (Number(selectedPlayer.value) || 0);

      if (newTotalSpent > 30) {
        alert("Total value of selected players cannot exceed 30.");
        return;
      }

      setPlayers((prevPlayers) =>
        prevPlayers.map((player) =>
          player._id === playerId ? { ...player, selected: true } : player
        )
      );

      setSelectedPlayers((prevSelected) => {
        if (!prevSelected.some((p) => p._id === playerId)) {
          return [...prevSelected, selectedPlayer];
        }
        return prevSelected;
      });
    }

    setBuyModal(true);
  };

  const handleBuyClick1 = (player = null) => {
    let newSelectedPlayers = [];

    if (player) {
      newSelectedPlayers = [player];
    } else {
      newSelectedPlayers = players.filter((p) => p.selected);
    }

    if (newSelectedPlayers.length === 0) {
      alert("Please select at least one player.");
      return;
    }

    setSelectedPlayers(newSelectedPlayers);
    setBuyModal(true);
  };

  const confirmTeam1 = async () => {
    if (isMarketFrozen) {
      showAutoError("The market is frozen. Please try again later.");
      return;
    }

    setIsLoading(true);
    const Token = localStorage.getItem("user_token");
    if (!Token) {
      showAutoError("User token is missing. Please log in.");
      return;
    }

    try {
      const decodedToken = JSON.parse(atob(Token.split(".")[1]));
      const userId = decodedToken._id;

      if (!selectedPlayers) {
        showAutoError("No players selected for purchase or team creation.");
        return;
      }

      if (selectedPlayer) {
        const existingShares = selectedPlayer.share_quantity || 0;
        const newShares = playerShares[selectedPlayer._id] || 1;
        const totalShares = existingShares + newShares;

        const addPlayers = [
          {
            playerId: selectedPlayer._id || selectedPlayer.player_id,
            share_quantity: totalShares,
          },
        ];
        setSelectedPlayers((prevPlayers) =>
          prevPlayers.map((player) =>
            player._id === selectedPlayer._id
              ? {
                ...player,
                share_quantity: totalShares,
              }
              : player
          )
        );
        const res = await fetch(
          `https://toptennis.io/api/users/getplayerfreeze/${selectedPlayer._id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: `Bearer ${Token}`,
            },
          }
        );

        const data = await res.json();

        if (data.isPlayerFrozen) {
          showAutoError("This player is currently frozen. You cannot buy.");
          return;
        }
        try {
          const response = await axios.post(
            `https://toptennis.io/api/users/updateTeam/${userId}`,
            { addPlayers },
            {
              headers: {
                Authorization: `Bearer ${Token}`,
                "Content-Type": "application/json",
              },
            }
          );

          if (response.data.message) {
            await fetchSelectedTeamList();
            await fetchPlayersAndMarkSelected();
            setIsLoading(false);
            showAutoCloseAlert("Player updated successful!");
            await handleCloseModal();
          } else {
            showAutoError("Error during player purchase.");
          }
          await fetchPlayersAndMarkSelected();
          await fetchSelectedTeamList();
        } catch (purchaseError) {
          console.error(purchaseError);
          if (
            purchaseError.response?.data?.message ===
            "User account is frozen. Action not allowed."
          ) {
            showAutoError("The user is frozen. Please try again later.");
            return;
          }
          if (purchaseError.response && purchaseError.response.data) {
            showAutoError(purchaseError.response.data.error);
          }
        }
        handleClose();
        handleCloseModal();
        handleConfirmClose();
        return;
      }
    } catch (error) {
      console.error("Error confirming team:", error);
      if (
        error.response?.data?.message ===
        "User account is frozen. Action not allowed."
      ) {
        showAutoError("The user is frozen. Please try again later.");
        return;
      }
      showAutoError("Network error. Please try again later.");
    } finally {
      handleConfirmClose();
      handleClose();
      setIsLoading(false);
      await fetchPlayersAndMarkSelected();
      await fetchSelectedTeamList();
    }
  };

  const confirmTeam = async () => {
    if (isMarketFrozen) {
      showAutoError("The market is frozen. Please try again later.");
      return;
    }
    if (frozenUsers) {
      showAutoError("The user is frozen. Please try again later.");
      return;
    }
    setIsLoading(true);
    const Token = localStorage.getItem("user_token");
    if (!Token) {
      showAutoError("User token is missing. Please log in.");
      return;
    }

    try {
      const decodedToken = JSON.parse(atob(Token.split(".")[1]));
      const userId = decodedToken._id;

      if (!selectedPlayers || selectedPlayers.length === 0) {
        showAutoError("No players selected for purchase or team creation.");
        return;
      }

      const finalPlayers = selectedPlayers
        .filter((player) => typeof player === "object" && player._id)
        .slice(0, 8);
      const addPlayers = finalPlayers.map((player) => ({
        playerId: player._id,
        share_quantity: playerShares[player._id] || player.share_quantity || 1,
      }));

      console.log("Final 8 Players Sent:", addPlayers);
      const res = await fetch(
        `https://toptennis.io/api/users/getplayerfreeze/${selectedPlayer._id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${Token}`,
          },
        }
      );

      const data = await res.json();

      if (data.isPlayerFrozen) {
        showAutoError("This player is currently frozen. You cannot buy.");
        return;
      }
      setSelectedPlayers(finalPlayers);

      const response = await axios.post(
        `https://toptennis.io/api/users/updateTeam/${userId}`,
        { addPlayers },
        {
          headers: {
            Authorization: `Bearer ${Token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.message) {
        showAutoCloseAlert("Team successfully updated!");
        setBuyModal(false);
        setIsLoading(false);
        setRandomlyAddedPlayerId(null); // ✅ CONFIRMED → NO CLEANUP
        await fetchPlayersAndMarkSelected();
        await fetchSelectedTeamList();
      } else {
        showAutoError("Error updating the team.");
      }

      setSelectedPlayers((prevPlayers) => prevPlayers.slice(0, 8));
    } catch (error) {
      console.error("Error confirming team:", error);

      if (error.response) {
        showAutoError(
          error.response.data.error ||
          error.response.data.message ||
          "Something went wrong."
        );
      } else if (error.request) {
        showAutoError("Server not responding. Please try again.");
      } else {
        showAutoError("Unexpected error occurred.");
      }
    } finally {
      handleBuyClose();
      handleConfirmClose();
      handleClose();
      setIsLoading(false);
      await fetchPlayersAndMarkSelected();
      await fetchSelectedTeamList();
    }
  };

  const confirmFirstTeam = async () => {
    if (isMarketFrozen) {
      showAutoError("The market is frozen. Please try again later.");
      return;
    }
    if (frozenUsers) {
      showAutoError("The user is frozen. Please try again later.");
      return;
    }
    setIsLoading(true);
    const Token = localStorage.getItem("user_token");
    if (!Token) {
      showAutoError("User token is missing. Please log in.");
      return;
    }

    try {
      const decodedToken = JSON.parse(atob(Token.split(".")[1]));
      const userId = decodedToken._id;
      if (!userId) {
        showAutoError("Invalid user token. Please log in again.");
        return;
      }

      if (!selectedPlayers || selectedPlayers.length === 0) {
        showAutoError("No players selected for purchase or team creation.");
        return;
      }

      const hasInvalidShares = selectedPlayers.some(
        (player) => !playerShares[player._id] || playerShares[player._id] < 1
      );
      if (hasInvalidShares) {
        showAutoError("Please enter a minimum of 1 share per player.");
        return;
      }
      const finalPlayers = selectedPlayers.slice(0, 8);
      const formData = new FormData();

      const playersData = finalPlayers.map((player) => ({
        id: player._id || "",
        share_quantity: playerShares[player._id] || 0,
        name: player.name || "",
        value: player.value || 0,
      }));

      formData.append("players", JSON.stringify(playersData));

      try {
        const response = await axios.post(
          `https://toptennis.io/api/users/add-team/${userId}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${Token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log("API Response:", response.data);

        const teamCost = response.data.TeamCost || 0;
        setTeamCost(teamCost);

        setCredits(response.data.remainingCredits);

        const updatedPlayers = response.data.updatedPlayers || [];
        setSelectedPlayers((prevPlayers) =>
          prevPlayers.slice(0, 8).map((player) => {
            const updatedPlayer = updatedPlayers.find(
              (p) => p.id === player._id
            );
            return updatedPlayer
              ? { ...player, share_quantity: updatedPlayer.share_quantity }
              : player;
          })
        );

        localStorage.setItem("first_team_created", "true");
        setIsFirstTeamCreated(true);

        showAutoCloseAlert("Team created successfully!");
        setIsLoading(false);
        await fetchUserValues();
      } catch (addTeamError) {
        console.error("API Error Response:", addTeamError.response?.data);

        if (addTeamError.response) {
          const errorMessage =
            addTeamError.response.data.message ||
            addTeamError.response.data.error ||
            "Something went wrong.";

          showAutoError(errorMessage);
        } else {
          showAutoError("Server not responding. Please try again.");
        }
      }
    } catch (error) {
      console.error("Error confirming team:", error);
      showAutoError("Network error. Please try again later.");
    } finally {
      handleBuyClose();
      handleConfirmClose();
      handleClose();
      setIsLoading(false);
      await fetchPlayersAndMarkSelected();
      await fetchSelectedTeamList();
    }
  };

  useEffect(() => {
    setCurrentInput("");
    setTeamInput("");
  }, [selectedPlayer]);

  // Fetch players via socket
  const fetchPlayers = () => {
    socket.emit("getPlayers");
  };

  // Handle socket events for players
  useEffect(() => {
    fetchPlayers();

    socket.on("playersList", (data) => {
      if (data.status && Array.isArray(data.data)) {
        setPlayers(data.data);
        setFilteredPlayers(data.data);
      } else {
        console.error("Error fetching players:", data.message);
        showAutoError("Failed to fetch players");
      }
    });

    socket.on("playerUpdate", (data) => {
      console.log("Received playerUpdate:", data);
      const updatedPlayer = data.valueDifferences[0];
      if (!updatedPlayer) return;

      setPlayers((prevPlayers) =>
        prevPlayers.map((player) =>
          player._id === updatedPlayer.player_id
            ? {
              ...player,
              value: updatedPlayer.value,
              valueDifference: updatedPlayer.valueDifference,
              share_quantity: updatedPlayer.share_quantity || player.share_quantity,
              profile_image: updatedPlayer.profile_image || player.profile_image,
              name: updatedPlayer.name || player.name,
            }
            : player
        )
      );

      setBuyPlayer((prevBuyPlayer) =>
        prevBuyPlayer.map((player) =>
          player && player.player_id === updatedPlayer.player_id
            ? { ...player, ...updatedPlayer }
            : player
        )
      );

      setTeamCost((prevTeamCost) => {
        const player = data.valueDifferences[0];
        const delta = player.value - (player.base_value || player.value);
        const shares = player.share_quantity || 0;
        return prevTeamCost + delta * shares;
      });

      setInPlayValue((prevInPlayValue) => {
        const player = data.valueDifferences[0];
        const delta = player.value - (player.base_value || player.value);
        const shares = player.share_quantity || 0;
        return prevInPlayValue + delta * shares;
      });

      setDifferenceValue((prevDifference) => {
        const player = data.valueDifferences[0];
        const delta = player.value - (player.base_value || player.value);
        const shares = player.share_quantity || 0;
        return prevDifference + delta * shares;
      });
    });

    return () => {
      socket.off("playersList");
      socket.off("playerUpdate");
    };
  }, []);

  const fetchPlayersAndMarkSelected = async () => {
    setIsLoading(true);
    const Token = localStorage.getItem("user_token");

    try {
      const decodedToken = JSON.parse(atob(Token.split(".")[1]));
      const userId = decodedToken._id;

      const teamData = await new Promise((resolve) => {
        const listener = (data) => {
          socket.off("selectedTeamList", listener);
          resolve(data);
        };
        socket.on("selectedTeamList", listener);
        socket.emit("getSelectedTeamList");
      });

      if (!teamData.status) {
        throw new Error(teamData.message || "Error fetching team list");
      }

      setBuyPlayer(teamData.valueDifferences);

      const teamPlayers = teamData.team.players || [];
      const valueDifferences = teamData.valueDifferences || [];

      const valueDifferenceMap = valueDifferences.reduce((acc, diff) => {
        acc[diff.player_id] = diff.valueDifference;
        return acc;
      }, {});

      setPlayers((prevPlayers) =>
        prevPlayers.map((player) => {
          const selectedPlayer = teamPlayers.find((teamPlayer) =>
            String(teamPlayer._id) === String(player._id)
          );
          const valueDifference = valueDifferenceMap[player._id] || null;

          return {
            ...player,
            selected: teamPlayers.length > 0 ? !!selectedPlayer : player.selected,
            share_quantity: selectedPlayer ? selectedPlayer.share_quantity : null,
            valueDifference: valueDifference !== null ? valueDifference : null,
            value: player.value || 0,
          };
        })
      );
    } catch (error) {
      console.error("Error fetching selected team list:", error);
      showAutoError(error);
    }
    setIsLoading(false);
  };

  const fetchPlayersAndMarkSelectedWithoutLoader = async () => {
    const Token = localStorage.getItem("user_token");

    try {
      const decodedToken = JSON.parse(atob(Token.split(".")[1]));
      const userId = decodedToken._id;

      const teamData = await new Promise((resolve) => {
        const listener = (data) => {
          socket.off("selectedTeamList", listener);
          resolve(data);
        };
        socket.on("selectedTeamList", listener);
        socket.emit("getSelectedTeamList");
      });

      if (!teamData.status) {
        throw new Error(teamData.message || "Error fetching team list");
      }

      setBuyPlayer(teamData.valueDifferences);

      const teamPlayers = teamData.team.players || [];
      const valueDifferences = teamData.valueDifferences || [];

      const valueDifferenceMap = valueDifferences.reduce((acc, diff) => {
        acc[diff.player_id] = diff.valueDifference;
        return acc;
      }, {});

      setPlayers((prevPlayers) =>
        prevPlayers.map((player) => {
          const selectedPlayer = teamPlayers.find((teamPlayer) =>
            String(teamPlayer._id) === String(player._id)
          );
          const valueDifference = valueDifferenceMap[player._id] || null;

          return {
            ...player,
            selected: teamPlayers.length > 0 ? !!selectedPlayer : player.selected,
            share_quantity: selectedPlayer ? selectedPlayer.share_quantity : null,
            valueDifference: valueDifference !== null ? valueDifference : null,
            value: player.value || 0,
          };
        })
      );
    } catch (error) {
      console.error("Error fetching selected team list:", error);
      showAutoError(error);
    }
    setIsLoading(false);
  };

  const displayBuyPlayer = [
    ...(Array.isArray(buyPlayer) ? buyPlayer : []),
    ...Array(8 - (Array.isArray(buyPlayer) ? buyPlayer.length : 0)).fill(null),
  ].slice(0, 8);

  const showAutoCloseAlert = (message) => {
    Swal.fire({
      position: "top-end",
      icon: "success",
      title: message,
      showConfirmButton: false,
      timer: 1500,
    });
  };

  const showAutoError = (message) => {
    Swal.fire({
      position: "top-end",
      icon: "error",
      title: message,
      showConfirmButton: false,
      timer: 3000,
    });
  };

  const handleClose = () => setShow(false);

  const handleShow = () => {
    setShow(true);
    fetchPlayersAndMarkSelectedWithoutLoader();
  };

  const handleConfirmClose = () => setConfirmModal(false);

  const handleConfirmShow = () => setConfirmModal(true);

  const handleBuyPlayer = (playerId, iconIndex) => {
    if (isMarketFrozen) {
      showAutoError("Player purchases are currently disabled");
      return;
    }
    if (frozenUsers) {
      showAutoError("Player purchases are currently disabled");
      return;
    }
    const selectedPlayerObj = players.find((player) => player._id === playerId);
    if (!selectedPlayerObj) return;
    setPlayerShares((prevShares) => ({
      ...prevShares,
      [playerId]: prevShares[playerId] === undefined ? 1 : prevShares[playerId],
    }));
    if (selectedPlayerObj.selected) {
      setPlayers((prevPlayers) =>
        prevPlayers.map((player) =>
          player._id === playerId ? { ...player, selected: false } : player
        )
      );
      setSelectedIcons((prev) => {
        const newSelectedIcons = [...prev];
        const playerIndex = newSelectedIcons.findIndex(
          (icon) => icon && icon.name === selectedPlayerObj.name
        );
        if (playerIndex !== -1) newSelectedIcons[playerIndex] = null;
        return newSelectedIcons;
      });
      setSelectedPlayers((prevSelectedPlayers) =>
        prevSelectedPlayers.filter((player) => player._id !== playerId)
      );
    } else {
      if (selectedPlayers.length >= 8) {
        alert("You cannot select more than 8 players.");
        return;
      }
      const currentSelectedSum = players.reduce((acc, p) => acc + (p.selected ? (Number(p.value) || 0) : 0), 0);
      const newTotalSpent = currentSelectedSum + (Number(selectedPlayerObj.value) || 0);
      if (newTotalSpent > 30) {
        alert("Total value of selected players cannot exceed 30.");
        return;
      }
      setPlayers((prevPlayers) =>
        prevPlayers.map((player) =>
          player._id === playerId ? { ...player, selected: true } : player
        )
      );
      setSelectedIcons((prev) => {
        const newSelectedIcons = [...prev];
        newSelectedIcons[iconIndex] = {
          image: selectedPlayerObj.profile_image,
          name: selectedPlayerObj.name,
          value: selectedPlayerObj.value,
        };
        return newSelectedIcons;
      });
      setSelectedPlayers((prevSelectedPlayers) => {
        if (!prevSelectedPlayers.some((p) => p._id === playerId)) {
          return [...prevSelectedPlayers, selectedPlayerObj];
        }
        return prevSelectedPlayers;
      });
    }
    handleClose();
  };

  const handleConfirm = () => {
    if (selectedPlayers.length === 8) {
      handleConfirmShow();
    } else {
      alert("Please select 8 players to complete your team.");
    }
  };

  const handleSharesChange = (playerId, value) => {
    setPlayerShares((prevShares) => {
      const prevValue = prevShares[playerId] || 0;
      const updatedShares = { ...prevShares, [playerId]: value };

      const player = players.find((p) => p._id === playerId);
      if (!player) return prevShares;

      const prevTotalCost = prevValue * player.value;
      const newTotalCost = value * player.value;

      setTeamCost(
        (prevTeamCost) => prevTeamCost - prevTotalCost + newTotalCost
      );

      return updatedShares;
    });
  };

  const handlePostData = (e, playerId) => {
    const { value } = e.target;
    setPlayerShares((prevShares) => ({
      ...prevShares,
      [playerId]: Number(value),
    }));
  };

  const [modalType, setModalType] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  const handleBuyClick = (player) => {
    if (!player || !player._id) {
      showAutoError("Player ID not found. Please select a valid player.");
      return;
    }
    const shares = playerShares[player._id] || player.share_quantity || 1;
    const totalCost = shares * player.value;
    const newPercentage = teamCost
      ? ((totalCost / teamCost) * 100).toFixed(2)
      : 0;

    setPlayerHasReached20((prev) => ({
      ...prev,
      [player._id]: newPercentage > 20,
    }));

    setSelectedPlayer(player);
    setModalType("buy");
    setModalVisible(true);
  };

  const handleSellClick = (player) => {
    if (!player || !player._id) {
      showAutoError("Player ID not found. Please select a valid player.");
      return;
    }

    setSelectedPlayer(player);
    setModalType("sell");
    setModalVisible(true);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
    setSelectedPlayer(null);
    setModalType(null);
  };

  const handleConfirmAction = async () => {
    try {
      if (modalType === "buy") {
        await confirmTeam1();
      } else if (modalType === "sell") {
        await handleSellConfirm();
      }

      handleCloseModal();
      setTimeout(async () => {
        await fetchUserValues();
        await fetchSelectedTeamList();
      }, 500);
    } catch (error) {
      console.error("Action failed:", error);
      showAutoError("Something went wrong. Please try again.");
    }
  };

  // Fetch user in-play values via socket
  const fetchUserValues = () => {
    const Token = localStorage.getItem("user_token");
    if (Token) {
      const decodedToken = JSON.parse(atob(Token.split(".")[1]));
      const userId = decodedToken._id;
      socket.emit("getUserInPlayValue", { userId });
    }
  };

  // Handle socket events for user in-play values
  useEffect(() => {
    socket.on("userInPlayValue", (data) => {
      if (data.status) {
        setUserInPlayData(data);
        setUserName(data.name || "");
        setCredits(data.credits || 0);
        setWithdrawableCredits(data.withdrawableCredits || 0);
        setInPlayValue(data.grand_total_value || 0);
        setDifferenceValue(data.differenceValue || 0);
        setplayerval(data.latest_inc || 0);
        setTotalDeposit(data.totalDeposit || 0);
      } else {
        console.error("Error fetching user in-play value:", data.message);
        showAutoError("Failed to fetch user data");
      }
    });

    socket.on("userInPlayUpdate", (data) => {
      console.log("Received userInPlayUpdate:", data);
      if (data.status) {
        setUserInPlayData(data);
        setUserName(data.name || "");
        setCredits(data.credits || 0);
        setWithdrawableCredits(data.withdrawableCredits || 0);
        setInPlayValue(data.grand_total_value || 0);
        setTotalSpent(data.player_value_sum || 0);
        setDifferenceValue(data.differenceValue || 0);
        setplayerval(data.latest_inc || 0);
        setTotalDeposit(data.totalDeposit || 0);
      }
    });

    fetchUserValues();

    return () => {
      socket.off("userInPlayValue");
      socket.off("userInPlayUpdate");
    };
  }, []);

  const teamCostRef = useRef(0);

  const fetchSelectedTeamList = () => {
    socket.emit('getSelectedTeamList');
  };

  useEffect(() => {
    fetchSelectedTeamList();
  }, []);

  useEffect(() => {
    const Token = localStorage.getItem("user_token");
    if (Token) {
      const decodedToken = JSON.parse(atob(Token.split(".")[1]));
      const userId = decodedToken._id;

      if (userId) {
        socket.emit("joinUserRoom", userId);
      }

      socket.on("playerUpdate", (data) => {
        console.log("Received playerUpdate:", data);
        const receivedPlayer = data.valueDifferences[0];
        if (!receivedPlayer) return;

        const playerId = receivedPlayer.player_id;

        setBuyPlayer((prevBuyPlayer) => {
          return prevBuyPlayer.map((player) => {
            if (player.player_id === playerId) {
              const oldValue = player.value;
              const newValue = receivedPlayer.value;
              const delta = newValue - oldValue;
              const shares = player.share_quantity;

              setTeamCost((prevTeamCost) => prevTeamCost + delta * shares);
              setInPlayValue((prevInPlayValue) => prevInPlayValue + delta * shares);
              setDifferenceValue((prevDifference) => prevDifference + delta * shares);

              return {
                ...player,
                value: newValue,
                valueDifference: receivedPlayer.valueDifference,
              };
            }
            return player;
          });
        });
      });

      socket.on('selectedTeamList', (data) => {
        if (data.status) {
          setBuyPlayer(data.valueDifferences);
          const newTeamCost = data.TeamCost || 0;
          if (newTeamCost !== teamCostRef.current) {
            setTeamCost(newTeamCost);
            teamCostRef.current = newTeamCost;
          }
          fetchUserValues();
        } else {
          console.error("Error fetching selected team list:", data.message);
        }
      });

      return () => {
        socket.off("playerUpdate");
        socket.off('selectedTeamList');
      };
    }
  }, []);

  const handleSellConfirm = async () => {
    if (isMarketFrozen) {
      showAutoError("The market is frozen. Please try again later.");
      return;
    }
    setIsLoading(true);
    if (!selectedPlayer || !selectedPlayer._id) {
      showAutoError("Please select a player before confirming the sale.");
      return;
    }
    const Token = localStorage.getItem("user_token");
    const decodedToken = JSON.parse(atob(Token.split(".")[1]));
    const userId = decodedToken?._id;
    if (!userId) {
      showAutoError("Invalid user session. Please log in again.");
      return;
    }
    try {
      const quantityToSell =
        playerShares[selectedPlayer._id] ||
        playerShares[selectedPlayer.player_id] ||
        selectedPlayer.share_quantity ||
        1;
      const remainingShares =
        (selectedPlayer.share_quantity || 0) - quantityToSell;
      const playerId = selectedPlayer.player_id || selectedPlayer._id;
      if (!playerId) {
        showAutoError("Player ID is missing. Please try again.");
        return;
      }
      const res = await fetch(
        `https://toptennis.io/api/users/getplayerfreeze/${playerId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${Token}`,
          },
        }
      );
      const data = await res.json();
      if (data.isPlayerFrozen) {
        showAutoError("This player is currently frozen. You cannot sell.");
        return;
      }
      const requestBody = {
        playerId: playerId,
        share_quantity: quantityToSell,
        removePlayers: remainingShares <= 0 ? [selectedPlayer.player_id] : [],
      };
      const response = await axios.patch(
        `https://toptennis.io/api/users/sell-player/${userId}`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.message) {
        setIsLoading(false);
        showAutoCloseAlert("Player sold successfully!");
        setModalVisible(false);
        await fetchPlayersAndMarkSelected();
        await fetchSelectedTeamList();
      } else {
        showAutoError(response.data.message);
      }
    } catch (error) {
      console.error("API Error:", error.response.data.error);
      if (
        error.response?.data?.error ===
        "Cannot sell/remove player(s). Team must always have at least 7 players."
      ) {
        showAutoError(
          "Please complete your team before selling another player."
        );
        return;
      }
      if (
        error.response?.data?.message ===
        "User account is frozen. Action not allowed."
      ) {
        showAutoError("The user is frozen. Please try again later.");
        return;
      }
      showAutoError("Network error. Please try again later.");
    } finally {
      handleConfirmClose();
      handleClose();
      setOpenModal(false);
      setIsLoading(false);
      await fetchPlayersAndMarkSelected();
      await fetchSelectedTeamList();
    }
  };

  useEffect(() => {
    if (selectedPlayer) {
      setPlayerShares((prev) => ({
        ...prev,
        [selectedPlayer._id]: selectedPlayer.share_quantity || 0,
      }));
    }
  }, [selectedPlayer]);

  const [show1, setShow1] = useState(false);

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const handleLogout = () => {
    localStorage.removeItem("user_token");
    localStorage.removeItem("fullName");
    localStorage.removeItem("userId");
    localStorage.removeItem("user_isfrozen");
    localStorage.removeItem("email");
    console.log("User logged out successfully.");
    navigate("/");
  };

  const showFreezeBanner = () => {
    return (
      <div className="freeze-banner">
        <p>{freezeMessage}</p>
      </div>
    );
  };

  const fetchMarketStatus = () => {
    socket.emit('getMarketStatus');
  };

  useEffect(() => {
    showFreezeBanner();
    fetchMarketStatus();

    socket.on('marketStatus', (data) => {
      setIsMarketFrozen(data.isFrozen);
      setFreezeMessage(data.bannerText || "");
      fetchPlayersAndMarkSelectedWithoutLoader();
      fetchSelectedTeamList();
    });

    socket.on('marketFreezeUpdate', (data) => {
      console.log('Received market freeze update:', data);
      setIsMarketFrozen(data.freeze);
      setFreezeMessage(data.message);
      fetchPlayersAndMarkSelectedWithoutLoader();
      fetchSelectedTeamList();
    });

    socket.on('playerFreezeUpdate', (data) => {
      console.log('Received player freeze update:', data);
      window.location.reload();
    });

    return () => {
      socket.off('marketStatus');
      socket.off('marketFreezeUpdate');
      socket.off('playerFreezeUpdate');
    };
  }, []);

  const handleSellAll = async () => {
    if (isMarketFrozen) {
      showAutoError("The market is frozen. Please try again later.");
      return;
    }
    const firstConfirm = window.confirm(
      "Are you sure you want to sell all players?"
    );

    if (!firstConfirm) return;

    const secondConfirm = window.confirm(
      "Please note that selling all players at once will result in a reduction of 20 credits.\n\nPlease confirm you wish to proceed with the SELL ALL PLAYERS request."
    );

    if (!secondConfirm) return;

    try {
      const Token = localStorage.getItem("user_token");

      const response = await fetch(
        "https://toptennis.io/api/users/sellallplayer",
        {
          method: "POST",
          headers: {
            authorization: `Bearer ${Token}`,
          },
        }
      );

      const data = await response.json();

      if (!response.ok) {
        // Handle API 400 error for "No players to sell."
        if (response.status === 400 && data.message === "No players to sell.") {
          showAutoError("No players to sell.");
          return;
        } else {
          throw new Error(data.message || "Failed to sell all players");
        }
      }

      window.location.reload();
      alert(data.message);
      console.log(data, "DATA");

      setBuyPlayer([]);
      setSelectedPlayers([]);
      setSelectedIcons(Array(8).fill(null));
      setFilteredPlayers((prev) =>
        prev.map((player) => ({ ...player, selected: false }))
      );
      setCredits(data.currentCredits);
      setInPlayValue(0);

      setTimeout(() => {
        fetchSelectedTeamList();
      }, 500);
    } catch (error) {
      console.error("Sell all failed:", error);
      alert(
        error.message === "No players to sell."
          ? "No players to sell."
          : "Something went wrong while selling all players."
      );
    }
  };

  useEffect(() => {
    setIsFirstTeamCreated(localStorage.getItem("first_team_created") === "true");
  }, []);

  const isAnyPlayerValueChanged = () => {
    if (!buyPlayer || !Array.isArray(buyPlayer)) return false;
    return buyPlayer.some(player => player && player.valueDifference && player.valueDifference !== 0);
  };

  useEffect(() => {
    if (isFirstTeamCreated && isAnyPlayerValueChanged()) {
      localStorage.removeItem("first_team_created");
      setIsFirstTeamCreated(false);
    }
  }, [buyPlayer, isFirstTeamCreated]);

  // Sorting and filtering logic
  useEffect(() => {
    let sortedPlayers = [...players];

    switch (sortOption) {
      case "Player name A-Z":
        sortedPlayers.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case "Player name Z-A":
        sortedPlayers.sort((a, b) => b.name.localeCompare(a.name));
        break;
      case "Value High-Low":
        sortedPlayers.sort((a, b) => b.value - a.value);
        break;
      case "Value Low-High":
        sortedPlayers.sort((a, b) => a.value - b.value);
        break;
      default:
        break;
    }

    const lowerCaseSearch = searchTerm.toLowerCase();
    const filtered = sortedPlayers.filter((player) =>
      player.name.toLowerCase().includes(lowerCaseSearch)
    );
    setFilteredPlayers(filtered);
  }, [searchTerm, players, sortOption]);

  useEffect(() => {
    fetchPlayersAndMarkSelected();
  }, []);

  useEffect(() => {
    const sum = players.reduce(
      (acc, p) => acc + (p.selected ? (Number(p.value) || 0) : 0),
      0
    );
    setTotalSpent(sum);
  }, [players]);

  // RandomPlayerSelection
  const handleRandomPlayerSelection = async () => {
    // Global safety checks
    if (isMarketFrozen || frozenUsers) {
      showAutoError("Player purchases are currently disabled");
      return;
    }

    const isInitialTeam =
      !Array.isArray(buyPlayer) || buyPlayer.length === 0;

    const isBackendPartialTeam =
      Array.isArray(buyPlayer) &&
      buyPlayer.length > 0 &&
      buyPlayer.length < 8;

    // ==================================================
    // MODE 1: INITIAL TEAM (NO BACKEND TEAM EXISTS)
    // ==================================================
    if (isInitialTeam) {
      const alreadySelected = players.filter((p) => p.selected);
      let currentCount = alreadySelected.length;
      let currentValue = alreadySelected.reduce(
        (sum, p) => sum + (Number(p.value) || 0),
        0
      );

      if (currentCount >= 8) {
        showAutoError("Team already has 8 players");
        return;
      }

      const eligiblePlayers = players.filter(
        (p) =>
          !p.selected &&
          !p.isPlayerFrozen &&
          typeof p.value === "number"
      );

      if (eligiblePlayers.length === 0) {
        showAutoError("No players available for random selection");
        return;
      }

      const shuffled = [...eligiblePlayers].sort(
        () => Math.random() - 0.5
      );

      const playersToSelect = [];

      for (const player of shuffled) {
        if (currentCount >= 8) break;

        const val = Number(player.value) || 0;
        if (currentValue + val > 30) continue;

        playersToSelect.push(player);
        currentValue += val;
        currentCount += 1;
      }

      if (playersToSelect.length === 0) {
        showAutoError("No valid random combination found");
        return;
      }

      // Update players (logic)
      setPlayers((prevPlayers) =>
        prevPlayers.map((p) =>
          playersToSelect.some((rp) => rp._id === p._id)
            ? { ...p, selected: true }
            : p
        )
      );

      // Update UI icons (append only)
      setSelectedIcons((prevIcons) => {
        const icons = [...prevIcons];
        const emptyIndexes = icons
          .map((icon, idx) => (icon === null ? idx : null))
          .filter((idx) => idx !== null);

        playersToSelect.forEach((player, i) => {
          if (emptyIndexes[i] !== undefined) {
            icons[emptyIndexes[i]] = {
              image: player.profile_image,
              name: player.name,
              value: player.value,
            };
          }
        });

        return icons;
      });

      // Update selectedPlayers
      setSelectedPlayers((prev) => [
        ...prev,
        ...playersToSelect.filter(
          (p) => !prev.some((sp) => sp._id === p._id)
        ),
      ]);

      // Default 1 share
      setPlayerShares((prev) => {
        const updated = { ...prev };
        playersToSelect.forEach((p) => {
          if (!updated[p._id]) updated[p._id] = 1;
        });
        return updated;
      });

      showAutoCloseAlert(
        `Randomly added ${playersToSelect.length} players`
      );
      handleClose();
      return;
    }

    // ==================================================
    // MODE 2: BACKEND TEAM EXISTS (FILL EMPTY SLOT SAFELY)
    // ==================================================
    if (isBackendPartialTeam) {
      try {
        const alreadySelected = players.filter(p => p.selected);
        const currentCount = alreadySelected.length;

        if (currentCount >= 8) {
          showAutoError("Team already has 8 players");
          return;
        }

        // Current team value (1 share logic)
        const currentValue = alreadySelected.reduce(
          (sum, p) => sum + (Number(p.value) || 0),
          0
        );

        // Eligible random players
        const eligiblePlayers = players.filter(
          (p) =>
            !p.selected &&
            !p.isPlayerFrozen &&
            typeof p.value === "number" &&
            currentValue + p.value <= 30
        );

        if (eligiblePlayers.length === 0) {
          showAutoError("No valid random player fits value limit");
          return;
        }

        // Pick ONE random player
        // Sort by lowest value first
        const sortedByValue = [...eligiblePlayers].sort(
          (a, b) => a.value - b.value
        );

        // Take lowest 40% players
        const cutoff = Math.max(1, Math.floor(sortedByValue.length * 0.4));
        const lowValuePool = sortedByValue.slice(0, cutoff);

        // Random pick from low-value pool
        const randomPlayer =
          lowValuePool[Math.floor(Math.random() * lowValuePool.length)];


        // 🔥 IMPORTANT: ALIGN WITH MANUAL BUY FLOW
        setSelectedPlayer(randomPlayer);
        setSelectedPlayers([randomPlayer]);

        // Default 1 share
        setPlayerShares((prev) => ({
          ...prev,
          [randomPlayer._id]: 1,
        }));

        // Mark player selected in UI
        setPlayers((prevPlayers) =>
          prevPlayers.map((p) =>
            p._id === randomPlayer._id
              ? { ...p, selected: true }
              : p
          )
        );

        setRandomlyAddedPlayerId(randomPlayer._id); // 🔥 TRACK
        // OPEN SAME BUY MODAL (quantity + confirm)
        setBuyModal(true);

        showAutoCloseAlert(`Random player selected: ${randomPlayer.name}`);
        // handleClose(); // close player list modal
      } catch (error) {
        console.error("Random selection failed:", error);
        showAutoError("Failed to select random player");
      }

      return;
    }


    // ==================================================
    // FALLBACK (SHOULD NEVER HIT)
    // ==================================================
    showAutoError("Random selection not allowed in this state");
  };

  const isInitialTeam = !Array.isArray(buyPlayer) || buyPlayer.length === 0;
  const canFillBackendTeam =
    Array.isArray(buyPlayer) && buyPlayer.length > 0 && buyPlayer.length < 8;

  return (
    <div className="container">
      {isLoading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}
      <>
        <div className="card1" style={{ background: "none" }}>
          <div className="card-header2">
            <div className="market-banner">
              <p>{showFreezeBanner()} </p>
            </div>

            <div className="user-info">
              <button
                variant="light"
                className="d-md-none menu-btn "
                onClick={handleShow1}
              >
                ☰ {/* Hamburger Icon */}
              </button>
              <div className="left-section1 d-flex1">
                <span className="welcome-text">Welcome, {userName}</span>
                <div className="top-navigation d-none d-md-flex">
                  <span className="nav-item" onClick={() => navigate("/home")}>
                    Home
                  </span>
                  <span
                    className="nav-item"
                    onClick={() => navigate("/profile")}
                  >
                    Profile
                  </span>
                  <span
                    className="nav-item active"
                    onClick={() => navigate("/myteam")}
                  >
                    My Team
                  </span>
                  <span className="nav-item" onClick={() => navigate("/faq")}>
                    FAQs
                  </span>

                  <span className="nav-item" onClick={() => navigate("/news")}>
                    News
                  </span>
                  <span className="nav-item" onClick={handleLogout}>
                    Logout
                  </span>
                </div>
              </div>

              <Offcanvas show={show1} onHide={handleClose1} placement="start">
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title>Menu</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <div className="mobile-nav">
                    <span
                      className="nav-item "
                      onClick={() => {
                        navigate("/home");
                        handleClose1();
                      }}
                    >
                      Home
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => {
                        navigate("/profile");
                        handleClose1();
                      }}
                    >
                      Profile
                    </span>
                    <span
                      className="nav-item active"
                      onClick={() => {
                        navigate("/myteam");
                        handleClose1();
                      }}
                    >
                      My Team
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => {
                        navigate("/faq");
                        handleClose1();
                      }}
                    >
                      FAQs
                    </span>

                    <span
                      className="nav-item"
                      onClick={() => navigate("/news")}
                    >
                      News
                    </span>
                    <span
                      className="nav-item"
                      onClick={() => {
                        handleLogout();
                        handleClose1();
                      }}
                    >
                      Logout
                    </span>
                  </div>
                </Offcanvas.Body>
              </Offcanvas>

              <div className="right-section1">
                <div className="credit-box-container">
                  <button
                    className="topup-button"
                    onClick={() => {
                      navigate("/topup");
                    }}
                  >
                    Top-up
                  </button>
                  <div className="credit-box">
                    <p className="p">
                      Credit available: <span>{format2(credits + withdrawableCredits)}</span>
                    </p>
                    <p className="p">
                      Withdrawable Credit: <span>{format2(withdrawableCredits)}</span>
                    </p>
                    <p className="p">
                      In-play: <span>{inPlayValue.toFixed(2)}</span>
                    </p>
                    <p className="p">
                      Current Team P/L:&nbsp;
                      <span
                        style={{
                          color: (isFirstTeamCreated && !isAnyPlayerValueChanged())
                            ? "black"
                            : Number(differenceValue) > 0
                              ? "green"
                              : Number(differenceValue) < 0
                                ? "red"
                                : "black",
                        }}
                      >
                        {(isFirstTeamCreated && !isAnyPlayerValueChanged())
                          ? "0.00"
                          : differenceValue
                            ? Number(differenceValue) > 0
                              ? `+${Number(differenceValue).toFixed(2)}`
                              : Number(differenceValue).toFixed(2)
                            : "0.00"}
                      </span>
                      &nbsp;
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Modal
            show={show}
            onHide={handleClose}
            animation={false}
            centered
            size="lg"
          >
            <Modal.Header>
              <Modal.Title style={{ width: "100%" }}>
                <h4
                  style={{
                    fontWeight: 500,
                    color: "#fff",
                    marginBottom: 0,
                    minWidth: 55,
                  }}
                >
                  Buy and Sell players below.
                </h4>
                <h4 className="modal-h1">Player Selection</h4>

                <div style={{ marginTop: "10px" }}>
                  <div
                    className="search-sell-wrapper"
                    style={{ display: "flex", gap: 12, marginBottom: 8 }}
                  >
                    {/* Sort by */}
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <label
                        htmlFor="sort-dropdown"
                        style={{
                          fontWeight: 400,
                          color: "#fff",
                          fontSize: "16px",
                          marginBottom: "5px",
                        }}
                      >
                        Sort by:
                      </label>
                      <select
                        id="sort-dropdown"
                        value={sortOption}
                        onChange={(e) => setSortOption(e.target.value)}
                        className="sort-dropdown"
                        style={{
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          background: "#f8f9fa",
                          padding: "5px 12px",
                          fontSize: 15,
                          minWidth: 200,
                          transition: "border 0.2s",
                        }}
                      >
                        <option value="Player name A-Z">Player name A-Z</option>
                        <option value="Player name Z-A">Player name Z-A</option>
                        <option value="Value High-Low">Value High-Low</option>
                        <option value="Value Low-High">Value Low-High</option>
                      </select>
                    </div>
                    {/* Random Player Button */}
                    <button
                      onClick={handleRandomPlayerSelection}
                      className="sell-all-button"
                      disabled={
                        isMarketFrozen ||
                        frozenUsers ||
                        (!isInitialTeam && !canFillBackendTeam) ||
                        selectedPlayers.length === 8
                      }
                      style={{
                        width: 230,
                        background:
                          isMarketFrozen ||
                            frozenUsers ||
                            (!isInitialTeam && !canFillBackendTeam) ||
                            selectedPlayers.length === 8
                            ? "#adb5bd"
                            : "linear-gradient(90deg, #7c3aed 40%, #6f42c1 100%)",
                        color: "white",
                        border: "none",
                        borderRadius: 6,
                        fontWeight: 600,
                        padding: "8px 18px",
                        fontSize: 15,
                        boxShadow: "0 2px 8px #0001",
                        opacity:
                          isMarketFrozen ||
                            frozenUsers ||
                            (!isInitialTeam && !canFillBackendTeam) ||
                            selectedPlayers.length === 8
                            ? 0.6
                            : 1,
                        cursor:
                          isMarketFrozen ||
                            frozenUsers ||
                            (!isInitialTeam && !canFillBackendTeam) ||
                            selectedPlayers.length === 8
                            ? "not-allowed"
                            : "pointer",
                      }}
                      title={
                        (!isInitialTeam && !canFillBackendTeam)
                          ? "Random selection is only available before team creation"
                          : selectedPlayers.length === 8
                            ? "Team already has 8 players"
                            : "Select random players"
                      }
                    >
                      <i className="fas fa-random" style={{ marginRight: 8 }}></i>
                      Select Random Players
                    </button>
                  </div>

                  <div
                    className="search-sell-wrapper"
                    style={{ display: "flex", gap: 12 }}
                  >
                    {/* Search */}
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <label
                        htmlFor="player-search"
                        style={{
                          fontWeight: 400,
                          color: "#fff",
                          fontSize: "16px",
                        }}
                      >
                        Search:
                      </label>
                      <input
                        id="player-search"
                        type="text"
                        placeholder="Search players"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input"
                        style={{
                          padding: "6px 12px",
                          borderRadius: "4px",
                          border: "1px solid #ced4da",
                          background: "#f8f9fa",
                          fontSize: 15,
                          width: "100%",
                          maxWidth: 220,
                          margin: 0,
                          marginLeft: 5,
                        }}
                      />
                    </div>
                    {/* Sell All Players Button */}
                    {buyPlayer && (
                      <button
                        onClick={handleSellAll}
                        className="sell-all-button"
                        disabled={
                          isMarketFrozen || !buyPlayer || buyPlayer.length !== 8
                        }
                        style={{
                          width: 230,
                          background:
                            isMarketFrozen ||
                              !buyPlayer ||
                              buyPlayer.length !== 8
                              ? "#adb5bd"
                              : "",
                          color: "white",
                          border: "none",
                          borderRadius: 6,
                          fontWeight: 600,
                          padding: "8px 18px",
                          fontSize: 15,
                          boxShadow: "0 2px 8px #0001",
                          opacity:
                            isMarketFrozen ||
                              !buyPlayer ||
                              buyPlayer.length !== 8
                              ? 0.6
                              : 1,
                          cursor:
                            isMarketFrozen ||
                              !buyPlayer ||
                              buyPlayer.length !== 8
                              ? "not-allowed"
                              : "pointer",
                          transition: "background 0.2s, opacity 0.2s",
                        }}
                        title={
                          isMarketFrozen
                            ? "Market is currently frozen"
                            : !buyPlayer || buyPlayer.length !== 8
                              ? "You need exactly 8 players in your team to use Sell All"
                              : "Sell all players in your team"
                        }
                      >
                        <i
                          className="fas fa-minus-circle"
                          style={{ marginRight: 8, fontSize: 15, opacity: 0.8 }}
                        ></i>
                        Sell All Players
                      </button>
                    )}
                  </div>
                </div>
              </Modal.Title>
            </Modal.Header>
            {buyPlayer && buyPlayer.length >= 1 ? (
              <Modal.Body
                className="custom-scrollbar"
                style={{ maxHeight: "350px", overflowY: "scroll" }}
              >
                <table
                  style={{ backgroundColor: "transparent", width: "100%" }}
                >
                  <thead>
                    <tr>
                      <th>Players (Shares Held)</th>
                      <th>Value</th>
                      <th>Trade</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(filteredPlayers) &&
                      filteredPlayers.length > 0 ? (
                      [...filteredPlayers]
                        .sort(
                          (a, b) => (b.selected ? 1 : 0) - (a.selected ? 1 : 0)
                        )
                        .map((player) => (
                          <tr key={player._id}>
                            <td>
                              <span
                                className={`circle ${player.selected ? "green-circle" : ""
                                  }`}
                                style={{
                                  width: "10px",
                                  height: "10px",
                                  borderRadius: "50%",
                                  display: player.selected
                                    ? "inline-block"
                                    : "none",
                                  margin: "0px 8px",
                                }}
                              ></span>
                              {player.name}
                              {player.selected && player.share_quantity ? (
                                <span
                                  style={{ marginLeft: "8px", color: "#ccc" }}
                                >
                                  ({player.share_quantity})
                                </span>
                              ) : null}
                            </td>
                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <div>
                                  {player.value?.toFixed(2) || "0.00"}
                                </div>
                                {player.share_quantity > 0 && (
                                  <div
                                    style={{
                                      display: "flex",
                                      marginTop: "5px",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: "white",
                                        fontWeight: "bolder",
                                        textAlign: "center",
                                      }}
                                      className="shre"
                                    >
                                      {(player.value * player.share_quantity).toFixed(2)}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </td>
                            <td>
                              {player.selected ? (
                                <>
                                  <button
                                    className="modal-button1 buy-button"
                                    style={{
                                      backgroundColor:
                                        isMarketFrozen ||
                                          frozenUsers ||
                                          player.isPlayerFrozen
                                          ? "gray"
                                          : "",
                                      cursor:
                                        isMarketFrozen ||
                                          frozenUsers ||
                                          player.isPlayerFrozen
                                          ? "not-allowed"
                                          : "pointer",
                                      opacity:
                                        isMarketFrozen ||
                                          frozenUsers ||
                                          player.isPlayerFrozen
                                          ? 0.6
                                          : 1,
                                    }}
                                    disabled={
                                      isMarketFrozen ||
                                      frozenUsers ||
                                      player.isPlayerFrozen
                                    }
                                    onClick={() => {
                                      if (
                                        isMarketFrozen ||
                                        frozenUsers ||
                                        player.isPlayerFrozen
                                      )
                                        return; // Prevent action if market is frozen
                                      if (!player || !player._id) {
                                        showAutoError(
                                          "Player ID not found. Please select a valid player."
                                        );
                                        return;
                                      }
                                      setSelectedPlayer(player); // Set selected player
                                      setConfirmModal(true); // Show modal
                                      handleBuyClick(player); // Trigger the modal opening function
                                      setIsConfirmed(true);
                                    }}
                                  >
                                    Buy
                                  </button>

                                  <button
                                    className="modal-button1 transfer-button"
                                    style={{
                                      marginLeft: "10px",
                                      backgroundColor:
                                        isMarketFrozen ||
                                          frozenUsers ||
                                          player.isPlayerFrozen
                                          ? "gray"
                                          : "red",
                                      cursor:
                                        isMarketFrozen ||
                                          frozenUsers ||
                                          player.isPlayerFrozen
                                          ? "not-allowed"
                                          : "pointer",
                                      opacity:
                                        isMarketFrozen ||
                                          frozenUsers ||
                                          player.isPlayerFrozen
                                          ? 0.6
                                          : 1,
                                    }}
                                    disabled={
                                      isMarketFrozen ||
                                      frozenUsers ||
                                      player.isPlayerFrozen
                                    }
                                    onClick={() => {
                                      if (
                                        isMarketFrozen ||
                                        frozenUsers ||
                                        player.isPlayerFrozen
                                      )
                                        return; // Prevent action if market is frozen
                                      if (!player || !player._id) {
                                        showAutoError(
                                          "Player ID not found. Please select a valid player."
                                        );
                                        return;
                                      }
                                      setSelectedPlayer(player);
                                      handleSellClick(player);
                                      setIsConfirmed(false);
                                    }}
                                  >
                                    Sell
                                  </button>
                                </>
                              ) : (
                                <button
                                  className="modal-button buy-button"
                                  disabled={
                                    isMarketFrozen ||
                                    frozenUsers ||
                                    player.isPlayerFrozen ||
                                    filteredPlayers.filter((p) => p.selected)
                                      .length >= 8
                                  }
                                  style={{
                                    opacity:
                                      isMarketFrozen ||
                                        frozenUsers ||
                                        player.isPlayerFrozen ||
                                        filteredPlayers.filter((p) => p.selected)
                                          .length >= 8
                                        ? 0.5
                                        : 1,
                                    cursor:
                                      isMarketFrozen ||
                                        frozenUsers ||
                                        player.isPlayerFrozen ||
                                        filteredPlayers.filter((p) => p.selected)
                                          .length >= 8
                                        ? "not-allowed"
                                        : "pointer",
                                    backgroundColor:
                                      isMarketFrozen ||
                                        frozenUsers ||
                                        player.isPlayerFrozen
                                        ? "gray"
                                        : "", // Gray if market is frozen
                                  }}
                                  onClick={() => {
                                    if (
                                      isMarketFrozen ||
                                      frozenUsers ||
                                      player.isPlayerFrozen
                                    )
                                      return; // Prevent action if market is frozen
                                    handleBuyClick1(player._id);
                                    setSelectedPlayer(player);
                                    // setSelectedPlayers([player]);
                                    handleBuyPlayer1(player._id);
                                    setIsConfirmed(true);
                                  }}
                                >
                                  Buy
                                </button>
                              )}
                            </td>
                          </tr>
                        ))
                    ) : (
                      <tr>
                        <td colSpan="3">No players available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Modal.Body>
            ) : (
              <Modal.Body
                className="custom-scrollbar"
                style={{ maxHeight: "350px", overflowY: "scroll" }}
              >
                <table
                  style={{ backgroundColor: "transparent", width: "100%" }}
                >
                  <thead>
                    <tr>
                      <td>Image</td>
                      <th>Players (Shares Held)</th> <th>Value</th>{" "}
                      <th>Trade</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(filteredPlayers) &&
                      filteredPlayers.length > 0 ? (
                      filteredPlayers.map((player) => (
                        <tr key={player._id}>
                          <td>
                            <img
                              src={
                                player.profile_image
                                  ? `https://toptennis.io/api/images/${player.profile_image}`
                                  : "/default-avatar.png"
                              }
                              alt="Player Profile"
                              className="profile_image"
                              style={{
                                width: "50px",
                                height: "50px",
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "/default-avatar.png";
                              }}
                            />
                          </td>
                          <td>{player.name}</td>
                          <td>{player.value?.toFixed(2)}</td>
                          <td>
                            {player.selected ? (
                              <button
                                className="modal-button"
                                style={{
                                  width: "60%",
                                  opacity: isMarketFrozen ? 0.5 : 1,
                                  cursor: isMarketFrozen
                                    ? "not-allowed"
                                    : "pointer",
                                  backgroundColor: isMarketFrozen ? "gray" : "", // Gray if market is frozen
                                }}
                                onClick={() =>
                                  handleBuyPlayer(
                                    player._id,
                                    selectedIcons.indexOf(null)
                                  )
                                }
                                disabled={isMarketFrozen}
                              >
                                Unselect
                              </button>
                            ) : (
                              <button
                                className="modal-button"
                                onClick={() =>
                                  handleBuyPlayer(
                                    player._id,
                                    selectedIcons.indexOf(null)
                                  )
                                }
                                disabled={
                                  isMarketFrozen ||
                                  frozenUsers ||
                                  player.isPlayerFrozen ||
                                  selectedPlayers.length >= 8
                                }
                                style={{
                                  opacity:
                                    isMarketFrozen ||
                                      frozenUsers ||
                                      player.isPlayerFrozen ||
                                      selectedPlayers.length >= 8
                                      ? 0.5
                                      : 1,
                                  cursor:
                                    isMarketFrozen ||
                                      frozenUsers ||
                                      player.isPlayerFrozen ||
                                      selectedPlayers.length >= 8
                                      ? "not-allowed"
                                      : "pointer",
                                  backgroundColor:
                                    isMarketFrozen ||
                                      frozenUsers ||
                                      player.isPlayerFrozen
                                      ? "gray"
                                      : "", // Gray if market is frozen
                                }}
                              >
                                Buy
                              </button>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4">No players available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Modal.Body>
            )}
          </Modal>
          {buyModal && selectedPlayers.length > 0 && (
            <Modal
              show={buyModal}
              onHide={!isLoading ? handleBuyClose : null}
              centered
              size="lg"
            >
              <Modal.Body style={{ backgroundColor: "white" }}>
                {selectedPlayers.length > 8 && (
                  <p style={{ color: "red", textAlign: "center" }}>
                    Maximum 8 players allowed!
                  </p>
                )}
                <table>
                  <thead>
                    <tr>
                      <th className="confirm-th">Name</th>
                      <th className="confirm-th">Value per Share</th>
                      <th className="confirm-th">Total Shares</th>
                      <th className="confirm-th">Total Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      // Calculate the total team cost dynamically
                      const updatedTotalTeamCost = players.reduce(
                        (acc, player) =>
                          acc +
                          (playerShares[player._id] ||
                            player.share_quantity ||
                            0) *
                          (player.value || 0),
                        0
                      );
                      return selectedPlayers
                        .filter(
                          (player) => playerShares[player._id] !== undefined
                        )
                        .map((player) => {
                          const shares =
                            playerShares[player._id] ||
                            player.share_quantity ||
                            0;
                          const totalCost = shares * player.value;

                          const percentage = updatedTotalTeamCost
                            ? (
                              (totalCost / updatedTotalTeamCost) *
                              100
                            ).toFixed(2)
                            : 0;

                          return (
                            <tr key={player._id}>
                              <td className="confirm-td">{player.name}</td>
                              <td className="confirm-td">
                                {player.value?.toFixed(2)}
                              </td>

                              <td className="confirm-td">
                                <input
                                  type="number"
                                  placeholder="1"
                                  value={
                                    playerShares[player._id] === undefined
                                      ? 1
                                      : playerShares[player._id] === 0
                                        ? ""
                                        : playerShares[player._id]
                                  }
                                  onChange={(e) => {
                                    let val = e.target.value.trim();

                                    // Ensure the value is a valid number
                                    if (!/^\d*$/.test(val)) {
                                      return;
                                    }

                                    val = val === "" ? 0 : parseInt(val, 10);

                                    // Calculate the potential new cost
                                    let newCost =
                                      teamCost +
                                      (val -
                                        (playerShares[player._id] === undefined
                                          ? 1
                                          : playerShares[player._id])) *
                                      player.value;

                                    // Update the team cost and input value
                                    setTeamCost(Number(newCost.toFixed(2)));
                                    setPlayerShares((prev) => ({
                                      ...prev,
                                      [player._id]: val,
                                    }));

                                    handleSharesChange(player._id, val);
                                  }}
                                  onKeyDown={(e) => {
                                    if (
                                      ["e", "E", "+", "-", "."].includes(e.key)
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  className="input-field inputfiled"
                                  min="1"
                                  max="99"
                                  step="1"
                                />
                              </td>

                              <td className="confirm-td">
                                <span>{totalCost?.toFixed(2)}</span>
                                <span
                                  style={{
                                    color: percentage > 20 ? "red" : "green",
                                    fontSize: "0.9em",
                                    marginLeft: "3px",
                                  }}
                                >
                                  (
                                  {String(
                                    Number(percentage).toFixed(2)
                                  ).padStart(5, "0")}
                                  %)
                                </span>
                              </td>
                            </tr>
                          );
                        });
                    })()}
                  </tbody>
                </table>
              </Modal.Body>

              <Modal.Footer
                style={{
                  backgroundColor: "white",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
              <button
                  className="btn3"
                  onClick={() => {
                    selectedPlayers.forEach((player) => handleBuyPlayer1(player._id));
                    confirmTeam();
                    setIsConfirmed(true);
                  }}
                  disabled={
                    isLoading ||
                    selectedPlayers.length > 8 ||
                    (() => {
                      const totalTeamCost = players.reduce(
                        (acc, player) =>
                          acc +
                          (playerShares[player._id] || player.share_quantity || 0) *
                            (player.value || 0),
                        0
                      );

                      return selectedPlayers.some((player) => {
                        const shares = playerShares[player._id] || player.share_quantity || 0;
                        const totalCost = shares * (player.value || 0);
                        const percentage = totalTeamCost
                          ? (totalCost / totalTeamCost) * 100
                          : 0;
                        return percentage > 20;
                      });
                    })()
                  }
                  style={{
                    backgroundColor: "#28a745",
                    color: "white",
                    padding: "10px 20px",
                    border: "none",
                    borderRadius: "5px",
                    cursor:
                      isLoading || selectedPlayers.length > 8 ||
                      (() => {
                        const totalTeamCost = players.reduce(
                          (acc, player) =>
                            acc +
                            (playerShares[player._id] || player.share_quantity || 0) *
                              (player.value || 0),
                          0
                        );

                        return selectedPlayers.some((player) => {
                          const shares = playerShares[player._id] || player.share_quantity || 0;
                          const totalCost = shares * (player.value || 0);
                          const percentage = totalTeamCost
                            ? (totalCost / totalTeamCost) * 100
                            : 0;
                          return percentage > 20;
                        });
                      })()
                        ? "not-allowed"
                        : "pointer",
                    opacity:
                      isLoading || selectedPlayers.length > 8 ||
                      (() => {
                        const totalTeamCost = players.reduce(
                          (acc, player) =>
                            acc +
                            (playerShares[player._id] || player.share_quantity || 0) *
                              (player.value || 0),
                          0
                        );

                        return selectedPlayers.some((player) => {
                          const shares = playerShares[player._id] || player.share_quantity || 0;
                          const totalCost = shares * (player.value || 0);
                          const percentage = totalTeamCost
                            ? (totalCost / totalTeamCost) * 100
                            : 0;
                          return percentage > 20;
                        });
                      })()
                        ? 0.4
                        : 1,
                  }}
                >
                  Confirm Team
                </button>
              </Modal.Footer>
            </Modal>
          )}

          {buyPlayer && buyPlayer.length >= 1 ? (
            selectedPlayer && (
              <Modal
                show={modalVisible}
                onHide={!isLoading ? handleCloseModal : null}
                centered
                size="lg"
              >
                <Modal.Body style={{ backgroundColor: "white" }}>
                  <table>
                    <thead>
                      <tr>
                        <th className="confirm-th">Name</th>
                        <th className="confirm-th">Value per share</th>
                        {/* <th className="confirm-th">Total Shares</th> */}
                        <th className="confirm-th">
                          {isConfirmed ? "CURRENT SHARES" : "TOTAL Holdings"}
                        </th>
                        <th className="confirm-th">
                          {isConfirmed ? "ADDITIONAL SHARES" : "TOTAL SELLING"}
                        </th>
                        <th className="confirm-th">
                          {isConfirmed ? "TOTAL VALUE" : "TOTAL RETURN"}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="confirm-td">{selectedPlayer.name}</td>
                        <td className="confirm-td">
                          {selectedPlayer.value.toFixed(2)}
                        </td>
                        <td className="confirm-td">
                          {selectedPlayer.share_quantity || 0}
                        </td>

                        <td className="confirm-td">
                          <Form.Control
                            type="number"
                            placeholder="Enter number of shares"
                            value={currentInput === 0 ? "" : currentInput} // Show empty if 0
                            onChange={(e) => {
                              let val = e.target.value.trim();

                              // ✅ Handle empty input properly
                              if (val === "") {
                                setCurrentInput(""); // Keep input field blank
                                setTeamCost((prevCost) => {
                                  if (modalType === "buy") {
                                    return (
                                      prevCost -
                                      (currentInput || 0) * selectedPlayer.value
                                    ); // Subtract last value when clearing
                                  } else if (modalType === "sell") {
                                    return (
                                      prevCost +
                                      (currentInput || 0) * selectedPlayer.value
                                    ); // Add back last value when clearing
                                  }
                                  return prevCost;
                                });
                                return;
                              }

                              // Ensure the value is a valid number
                              if (!/^\d*$/.test(val)) {
                                return;
                              }

                              val = parseInt(val, 10);

                              // Prevent entering a value greater than available shares when selling
                              if (
                                modalType === "sell" &&
                                val > selectedPlayer.share_quantity
                              ) {
                                return;
                              }

                              // ✅ Calculate the potential new cost based on modal type
                              setTeamCost((prevCost) => {
                                if (modalType === "buy") {
                                  return (
                                    prevCost -
                                    (currentInput || 0) * selectedPlayer.value +
                                    val * selectedPlayer.value
                                  );
                                } else if (modalType === "sell") {
                                  return (
                                    prevCost +
                                    (currentInput || 0) * selectedPlayer.value -
                                    val * selectedPlayer.value
                                  );
                                }
                                return prevCost;
                              });

                              setCurrentInput(val || ""); // ✅ Keep input state consistent

                              setPlayerShares((prev) => ({
                                ...prev,
                                [selectedPlayer._id]: val,
                              }));

                              handlePostData(
                                e,
                                selectedPlayer._id || selectedPlayer.player_id
                              );
                            }}
                            onKeyDown={(e) => {
                              if (["e", "E", "+", "-", "."].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            name="share_quantity"
                            min="1"
                            max={
                              modalType === "sell"
                                ? selectedPlayer.share_quantity || 0
                                : Infinity
                            }
                            step="1"
                          />
                        </td>
                        <td className="confirm-td">
                          {(
                            selectedPlayer.value *
                            (modalType === "buy"
                              ? Number(selectedPlayer.share_quantity || 0) + Number(currentInput || 0)
                              : Number(currentInput || 0))
                          ).toFixed(2)}

                          {(() => {
                            const cost = (
                              selectedPlayer.value *
                              (modalType === "buy"
                                ? Number(selectedPlayer.share_quantity || 0) + Number(currentInput || 0)
                                : Number(currentInput || 0))
                            ).toFixed(2);

                            const currentTotalValue = players.reduce((acc, p) => {
                              const shares = p._id === selectedPlayer._id 
                                ? (modalType === "buy" 
                                    ? Number(p.share_quantity || 0) + Number(currentInput || 0)
                                    : Number(currentInput || 0))
                                : Number(p.share_quantity || 0);
                              return acc + (shares * (p.value || 0));
                            }, 0);

                            const percentage = currentTotalValue
                              ? ((cost / currentTotalValue) * 100).toFixed(2)
                              : 0;

                            return (
                              modalType === "buy" && (
                                <span
                                  style={{
                                    color: percentage > 20 ? "red" : "green",
                                    fontSize: "0.9em",
                                    marginLeft: "3px",
                                  }}
                                >
                                  (
                                  {String(
                                    Number(percentage).toFixed(2)
                                  ).padStart(5, "0")}
                                  %)
                                </span>
                              )
                            );
                          })()}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Modal.Body>

                <Modal.Footer
                  style={{
                    backgroundColor: "white",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <button
                    className="btn3"
                    onClick={handleConfirmAction}
                    style={{
                      backgroundColor:
                        modalType === "buy"
                          ? Object.keys(playerHasReached20).some(
                            (playerId) =>
                              playerHasReached20[playerId] === true
                          )
                            ? "#d4edda"
                            : "#28a745"
                          : Object.keys(playerHasReached20).some(
                            (playerId) =>
                              playerHasReached20[playerId] === true
                          )
                            ? "#f8d7da"
                            : "red",
                      color: "white",
                      padding: "10px 20px",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                      opacity:
                        isLoading ||
                          selectedPlayer.share_quantity === 0 ||
                          currentInput === "" ||
                          (modalType === "buy" &&
                            ((selectedPlayer.value *
                              (Number(selectedPlayer.share_quantity || 0) + Number(currentInput || 0))) /
                              teamCost) *
                            100 >
                            20)
                          ? 0.4
                          : 1,
                    }}
                    disabled={
                      isLoading ||
                      selectedPlayer.share_quantity === 0 ||
                      currentInput === "" ||
                      (modalType === "buy" &&
                        (() => {
                          const currentSelectedCount = players.filter(p => p.selected || p.share_quantity > 0).length;
                          // Only block if team is full or nearly full (adjust as per client rule)
                          if (currentSelectedCount < 8) return false;

                          const cost = selectedPlayer.value * (Number(selectedPlayer.share_quantity || 0) + Number(currentInput || 0));
                          const currentTotalValue = players.reduce((acc, p) => {
                            const shares = p._id === selectedPlayer._id 
                              ? (Number(p.share_quantity || 0) + Number(currentInput || 0))
                              : Number(p.share_quantity || 0);
                            return acc + (shares * (p.value || 0));
                          }, 0);
                          return (cost / currentTotalValue) * 100 > 20;
                        })())
                    }
                  >
                    {modalType === "buy" ? "Confirm Buy" : "Confirm Sell"}
                  </button>
                </Modal.Footer>
              </Modal>
            )
          ) : (
            <Modal
              show={confirmModal}
              onHide={!isLoading ? handleConfirmClose : null}
              centered
              size="lg"
            >
              <Modal.Body style={{ backgroundColor: "white" }}>
                <table>
                  <thead>
                    <tr>
                      <th className="confirm-th">Name</th>
                      <th className="confirm-th">Value per share</th>
                      <th className="confirm-th">Total shares</th>
                      <th className="confirm-th">Total Cost</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedPlayers.map((player) => {
                      console.log(selectedPlayers)
                      console.log(player);
                      const shares = playerShares[player._id] || 0;
                      const totalCost = shares * player.value;
                      const totalTeamCost = selectedPlayers.reduce(
                        (acc, player) =>
                          acc + (playerShares[player._id] || 0) * player.value,
                        0
                      );
                      const percentage = totalTeamCost
                        ? ((totalCost / totalTeamCost) * 100).toFixed(2)
                        : 0;
                      return (
                        <tr key={player._id}>
                          <td className="confirm-td" style={{ color: "#000" }}>
                            {player.name}
                          </td>
                          <td className="confirm-td">
                            {player.value?.toFixed(2)}
                          </td>

                          <td className="confirm-td">
                            <input
                              type="number"
                              value={shares === 0 ? "" : shares}
                              onChange={(e) => {
                                let val = e.target.value;
                                if (val === "") {
                                  handleSharesChange(player._id, 0);
                                  return;
                                }

                                val = val.replace(/^0+/, "");

                                // Only allow numbers >= 1, no upper limit
                                if (parseInt(val, 10) < 1) {
                                  val = "";
                                }

                                handleSharesChange(
                                  player._id,
                                  parseInt(val, 10) || 0
                                );
                              }}
                              onInput={(e) => {
                                let inputValue = e.target.value;

                                if (inputValue === "") {
                                  e.target.value = "";
                                  return;
                                }

                                inputValue = inputValue.replace(/^0+/, "");
                                // Don't trim length; allow user to enter as many digits as they want

                                e.target.value = inputValue;
                              }}
                              className="input-field"
                              min="1"
                              step="1"
                            />
                          </td>

                          <td className="confirm-td">
                            <span>{Number(totalCost)?.toFixed(2)}</span>
                            <span
                              style={{
                                color:
                                  Number(percentage) > 20 ? "red" : "green",
                                fontSize: "0.9em",
                                marginLeft: "3px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              (
                              {String(Number(percentage).toFixed(2)).padStart(
                                5,
                                "0"
                              )}
                              %)
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td className="confirm-td">
                        <strong>Total</strong>
                      </td>
                      <td className="confirm-td" style={{ color: "#28a745" }}>
                        {selectedPlayers
                          .reduce((acc, player) => acc + player.value, 0)
                          .toFixed(2)}
                      </td>
                      <td className="confirm-td">
                        {selectedPlayers.reduce(
                          (acc, player) =>
                            acc + (playerShares[player._id] || 0),
                          0
                        )}
                      </td>
                      <td className="confirm-td">
                        {selectedPlayers
                          .reduce(
                            (acc, player) =>
                              acc +
                              (playerShares[player._id] || 0) * player.value,
                            0
                          )
                          .toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Modal.Body>
              <Modal.Footer
                style={{
                  backgroundColor: "white",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{ fontSize: "16px", color: "#000" }}
                  className="footer-div"
                >
                  Total value of purchase:
                  <span
                    style={{
                      color: "#000",
                      fontWeight: "bold",
                      marginLeft: "3px",
                    }}
                  >
                    {selectedPlayers
                      .reduce(
                        (acc, player) =>
                          acc + (playerShares[player._id] || 0) * player.value,
                        0
                      )
                      .toFixed(2)}
                    &nbsp;Credits
                  </span>
                </div>
                <button
                  className="btn3"
                  onClick={confirmFirstTeam}
                  disabled={
                    isLoading ||
                    selectedPlayers.some((player) => {
                      const shares = playerShares[player._id] || 0;
                      const totalCost = shares * player.value;
                      const totalTeamCost = selectedPlayers.reduce(
                        (acc, player) =>
                          acc + (playerShares[player._id] || 0) * player.value,
                        0
                      );
                      const percentage = totalTeamCost
                        ? (totalCost / totalTeamCost) * 100
                        : 0;
                      return percentage > 20;
                    })
                  }
                  style={{
                    backgroundColor: "#28a745",
                    color: "white",
                    padding: "10px 20px",
                    border: "none",
                    borderRadius: "5px",
                    cursor: selectedPlayers.some((player) => {
                      const shares = playerShares[player._id] || 0;
                      const totalCost = shares * player.value;
                      const totalTeamCost = selectedPlayers.reduce(
                        (acc, player) =>
                          acc + (playerShares[player._id] || 0) * player.value,
                        0
                      );
                      const percentage = totalTeamCost
                        ? (totalCost / totalTeamCost) * 100
                        : 0;
                      return percentage > 20;
                    })
                      ? "not-allowed"
                      : "pointer",
                    opacity: selectedPlayers.some((player) => {
                      const shares = playerShares[player._id] || 0;
                      const totalCost = shares * player.value;
                      const totalTeamCost = selectedPlayers.reduce(
                        (acc, player) =>
                          acc + (playerShares[player._id] || 0) * player.value,
                        0
                      );
                      const percentage = totalTeamCost
                        ? (totalCost / totalTeamCost) * 100
                        : 0;
                      return percentage > 20;
                    })
                      ? 0.4
                      : 1,
                  }}
                >
                  Confirm Team
                </button>
              </Modal.Footer>
            </Modal>
          )}

          <div className="card-body1">
            <div className="body-div1">
              {buyPlayer && buyPlayer.length >= 1 ? (
                <div className="d-flex flex-wrap">
                  <div className="d-flex justify-content-between w-100">
                    {displayBuyPlayer.slice(0, 4).map((icon, index) => (
                      <div
                        key={index}
                        className="icon1"
                        onClick={handleShow}
                      >
                        {icon ? (
                          <div className="player-container">
                            <img
                              src={`https://toptennis.io/api/images/${icon.profile_image}`}
                              alt="Player Profile"
                              className="player-image"
                            />
                            <div className="player-info">
                              <div
                                className="player-name-row"
                              >
                                <p
                                  className="player-name2"
                                  style={{ color: "black" }}
                                >
                                  {icon.name}
                                </p>
                                <span
                                  style={{
                                    fontSize: "20px",
                                    paddingLeft: "5px",
                                    color: "black",
                                  }}
                                >
                                  *
                                </span>
                                <p
                                  className="player-share-quantity"
                                  style={{
                                    marginLeft: "5px",
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    color: "black",
                                  }}
                                >
                                  {icon.share_quantity}
                                </p>
                              </div>
                              <div
                                className="d-flex"
                                style={{ paddingLeft: "10px" }}
                              >
                                <p
                                  className="player-value"
                                  style={{ fontSize: "14px", color: "black" }}
                                >
                                  {icon.value.toFixed(2)}
                                </p>
                                <p
                                  className="player-value-difference"
                                  style={{
                                    fontSize: "14px",
                                    marginLeft: "5px",
                                    color:
                                      icon?.valueDifference > 0
                                        ? "green"
                                        : icon?.valueDifference < 0
                                          ? "red"
                                          : "black",
                                  }}
                                >
                                  ({icon?.valueDifference > 0 ? "+" : ""}
                                  {icon?.valueDifference.toFixed(2)})
                                </p>
                                <a className="trade">Trade</a>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="add-player-wrapper">
                            <i
                              className="fa-solid fa-plus plusicon"
                              onClick={() => {
                                handleShow();
                              }}
                            ></i>
                            <a className="addPlayer">Add Player</a>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>

                  <div className="d-flex justify-content-between w-100 seclist">
                    {displayBuyPlayer.slice(4, 8).map((icon, index) => (
                      <div
                        key={index}
                        className="icon1"
                        onClick={handleShow}
                      >
                        {icon ? (
                          <div className="player-container" style={{ marginTop: "20px" }}>
                            <img
                              src={`https://toptennis.io/api/images/${icon.profile_image}`}
                              alt="Player Profile"
                              className="player-image"
                            />

                            <div className="player-info">
                              <div
                                className="player-name-row"
                              >
                                <p
                                  className="player-name2"
                                  style={{ color: "black" }}
                                >
                                  {icon.name}
                                </p>
                                <span
                                  style={{
                                    fontSize: "20px",
                                    paddingLeft: "5px",
                                    color: "black",
                                  }}
                                >
                                  *
                                </span>
                                <p
                                  className="player-share-quantity"
                                  style={{
                                    marginLeft: "5px",
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    color: "black",
                                  }}
                                >
                                  {icon.share_quantity}
                                </p>
                              </div>
                              <div
                                className="d-flex"
                                style={{ paddingLeft: "10px" }}
                              >
                                <p
                                  className="player-value"
                                  style={{ fontSize: "14px", color: "black" }}
                                >
                                  {icon.value.toFixed(2)}
                                </p>
                                <p
                                  className="player-value-difference"
                                  style={{
                                    fontSize: "14px",
                                    marginLeft: "5px",
                                    color:
                                      icon?.valueDifference > 0
                                        ? "green"
                                        : icon?.valueDifference < 0
                                          ? "red"
                                          : "black",
                                  }}
                                >
                                  ({icon?.valueDifference > 0 ? "+" : ""}
                                  {icon?.valueDifference.toFixed(2)})
                                </p>
                                <a className="trade">Trade</a>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="add-player-wrapper">
                            <i className="fa-solid fa-plus plusicon"></i>
                            <a className="addPlayer">Add Player</a>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="d-flex flex-wrap">
                  <div className="d-flex justify-content-between w-100">
                    {selectedIcons.slice(0, 4).map((icon, index) => (
                      <div key={index} className="icon1" onClick={handleShow}>
                        {icon ? (
                          <>
                            <div className="player-container">
                              <img
                                src={`https://toptennis.io/api/images/${icon.image}`}
                                alt="Player Profile"
                                className="player-image5"
                              />
                              <div className="player-info">
                                <p
                                  className="player-name"
                                  style={{ color: "black" }}
                                >
                                  {icon.name}
                                </p>
                                <p className="player-value">
                                  {icon.value.toFixed(2)}
                                </p>
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="add-player-wrapper">
                            <i className="fa-solid fa-plus plusicon"></i>
                            <a className="addPlayer">Add Player</a>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  <div className="d-flex justify-content-between w-100 mt-2">
                    {selectedIcons.slice(4, 8).map((icon, index) => (
                      <div key={index} className="icon1" onClick={handleShow}>
                        {icon ? (
                          <>
                            <div
                              className="player-container"
                              style={{ marginTop: "35px" }}
                            >
                              <img
                                src={`https://toptennis.io/api/images/${icon.image}`}
                                alt="Player Profile"
                                className="player-image5"
                              />
                              <div className="player-info">
                                <p
                                  className="player-name"
                                  style={{ color: "black" }}
                                >
                                  {icon.name}
                                </p>
                                <p className="player-value">
                                  {icon?.value?.toFixed(2)}
                                </p>
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="add-player-wrapper">
                            <i className="fa-solid fa-plus plusicon"></i>
                            <a className="addPlayer">Add Player</a>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="card-body3">
            <div className="body-div1">
              {buyPlayer && buyPlayer.length >= 1 ? (
                <div className="icon-grid">
                  {displayBuyPlayer.map((icon, index) => (
                    <div key={index} className="icon1" onClick={handleShow}>
                      {icon ? (
                        <div className="player-container">
                          <img
                            src={`https://toptennis.io/api/images/${icon.profile_image}`}
                            alt="Player Profile"
                            className="player-image5"
                          />
                          <div className="player-info">
                            <div
                              className="player-name-row"
                            >
                              <p
                                className="player-name2"
                                style={{ fontSize: "10px", fontWeight: "bold" }}
                              >
                                {icon.name}
                              </p>
                              <span style={{ fontSize: "10px", paddingLeft: "5px" }}>
                                *
                              </span>
                              <p
                                className="player-share-quantity"
                                style={{
                                  marginLeft: "5px",
                                  fontSize: "10px",
                                  fontWeight: "bold",
                                }}
                              >
                                {icon.share_quantity}
                              </p>
                            </div>
                            <div
                              className="d-flex"
                              style={{ paddingLeft: "10px" }}
                            >
                              <p
                                className="player-value"
                                style={{ fontSize: "10px", color: "black" }}
                              >
                                {icon.value.toFixed(2)}
                              </p>

                              <p
                                className="player-value-difference"
                                style={{
                                  fontSize: "10px",
                                  marginLeft: "5px",
                                  color:
                                    icon?.valueDifference > 0 ? "green" : "red",
                                }}
                              >
                                ({icon?.valueDifference > 0 ? "+" : ""}
                                {icon?.valueDifference.toFixed(2)})
                              </p>
                              <a className="trade">Trade</a>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="add-player-wrapper">
                          <i className="fa-solid fa-plus plusicon"></i>
                          <a className="addPlayer">Add Player</a>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="icon-grid">
                  {selectedIcons.map((icon, index) => (
                    <div key={index} className="icon1" onClick={handleShow}>
                      {icon ? (
                        <>
                          <div className="player-container">
                            <img
                              src={`https://toptennis.io/api/images/${icon.image}`}
                              alt="Player Profile"
                              className="player-image5"
                            />
                            <div className="player-info">
                              <p className="player-name2">{icon.name}</p>
                              <p className="player-value">
                                {icon.value?.toFixed(2)}
                              </p>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="add-player-wrapper">
                          <i className="fa-solid fa-plus plusicon"></i>
                          <a className="addPlayer">Add Player</a>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className="card-footer2">
            <div className="footer">
              <div className="footer-first1">
                {buyPlayer && buyPlayer.length >= 1
                  ? displayBuyPlayer && (
                    <button
                      className="btn9"
                      onClick={handleConfirm}
                      style={{
                        display: "none",
                      }}
                    >
                      Confirm ?
                    </button>
                  )
                  : selectedIcons && (
                    <button className="btn9" onClick={handleConfirm}>
                      Confirm ?
                    </button>
                  )}
              </div>
              <div className="d-flex">
                <div className="first1">
                  <h5 className="first-h5">
                    {filteredPlayers.filter((p) => p.selected).length}/8
                  </h5>
                  <p className="p1">selections</p>
                  <p className="p1">{totalSpent.toFixed(2)} spent</p>
                </div>
                <div className="second2">
                  {(() => {
                    const selectedCount = players.filter((p) => p.selected).length;
                    return [...Array(8)].map((_, index) => (
                      <div
                        key={index}
                        className="circle2"
                        style={{
                          backgroundColor: index < selectedCount ? "green" : "red",
                        }}
                      ></div>
                    ));
                  })()}
                </div>
              </div>
              <div className="footer-line"></div>

              <div className="footer-firstline">
                <div className="footer-sub">
                  <h4>Keep in touch</h4>
                  <h5>Join our newsletter. We promise not to spam!</h5>
                  <input
                    type="email"
                    placeholder="Email Address"
                    className="footer-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button className="subscribe-btn" onClick={handleSubscribe}>
                    Subscribe
                  </button>
                  {message && <p style={{ marginTop: "10px" }}>{message}</p>}
                </div>

                <div className="footer-sub1">
                  <h4>Quick links</h4>
                  <a href="/home" className="footer-link">
                    Home
                  </a>
                  <a href="/profile" className="footer-link">
                    Profile
                  </a>
                  <a href="/myteam" className="footer-link">
                    My Team
                  </a>
                  <a href="/news" className="footer-link">
                    News
                  </a>
                  <a href="/faq" className="footer-link">
                    FAQs
                  </a>
                </div>

                <div className="footer-sub1 secondicon">
                  <h4>Socials</h4>
                  <div className="social-icons">
                    <a
                      href="https://www.facebook.com/toptennisio/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-circle"
                      style={{ textDecoration: "none" }}
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a
                      href="https://www.instagram.com/toptennisuk"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-circle"
                      style={{ textDecoration: "none" }}
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  </div>
                  <div className="fl1">
                    <a
                      href="/terms"
                      className="footer-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      T&Cs
                    </a>
                    <a
                      href="/privacy"
                      className="footer-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </a>
                    <span className="footer-link">
                      Email: contact@toptennis.io
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
}

export default Building;